<template>
  <div>
    <epi-offcanvas :opening-event-name="openingEventName" title="가능한 일정">
      <template v-slot:body>
        <div class="d-flex flex-column gap-3">
          <div class="form-check">
            <label class="form-check-label">
              <input type="checkbox" class="form-check-input" />
              예약 요청을 받습니다</label
            >
          </div>

          <input type="text" class="form-control" placeholder="가능한 일정" />

          <epi-select placeholder="상담사" />

          <div class="d-flex flex-column flex-md-row gap-2 gap-md-1">
            <div class="flex-fill">
              <label>날짜</label>
              <epi-date-picker />
            </div>
            <div class="flex-fill">
              <label>시작 시간</label>
              <input type="time" class="form-control" />
            </div>
            <div class="flex-fill">
              <label>완료 시간</label>
              <input type="time" class="form-control" />
            </div>
          </div>

          <div class="d-flex align-items-center gap-3">
            <label>매</label>
            <input
              type="number"
              class="form-control form-control-sm"
              style="width: 60px"
              placeholder="1"
            />
            <epi-select
              v-model="recurrenceUnit"
              :candidates="['일', '주', '개월']"
              style="width: 80px"
            />
            <label>마다 반복합니다</label>
          </div>

          <div>
            <label class="form-label">요일별 반복</label>
            <div class="d-flex gap-2 fs-5">
              <span class="badge rounded-pill pointer bg-primary">일</span>
              <span class="badge rounded-pill pointer bg-dark bg-opacity-50"
                >월</span
              >
              <span class="badge rounded-pill pointer bg-primary">화</span>
              <span class="badge rounded-pill pointer bg-primary">수</span>
              <span class="badge rounded-pill pointer bg-primary">목</span>
              <span class="badge rounded-pill pointer bg-dark bg-opacity-50"
                >금</span
              >
              <span class="badge rounded-pill pointer bg-primary">토</span>
            </div>
          </div>

          <div class="vstack gap-2">
            <label class="from-label">반복 종료</label>
            <div class="form-check">
              <label class="form-check-label">
                <input type="radio" class="form-check-input" name="until" />
                없음</label
              >
            </div>
            <div class="form-check">
              <label class="form-check-label">
                <epi-date-picker class="d-inline-block" />
                에 종료
              </label>
              <input type="radio" class="form-check-input mt-2" name="until" />
            </div>
            <div class="form-check">
              <label class="form-check-label">
                <input
                  type="number"
                  class="form-control form-control-sm d-inline"
                  style="width: 80px"
                  placeholder="13"
                />
                회 반복 후 종료
              </label>
              <input type="radio" class="form-check-input mt-2" name="until" />
            </div>
          </div>

          <div class="hstack gap-2">
            <button class="btn btn-light">취소</button>
            <button class="btn btn-light">저장</button>
          </div>
        </div>
      </template>
    </epi-offcanvas>
  </div>
</template>

<script>
import { EventName } from "@/const";

export default {
  name: "WorkTimeAddOffcanvas",
  data() {
    return {
      openingEventName: EventName.WorkTimeAddOffcanvasOpening,
      recurrenceUnit: "일",
    };
  },
  mounted() {},
};
</script>
